// extracted by mini-css-extract-plugin
export var addButton = "_dh-4";
export var contentBlockImage = "_dh-i";
export var contentBlockWidgetPreview = "_dh-g";
export var fulfillmentCutoffWidgetPreview = "_dh-9";
export var imageBackdrop = "_dh-6";
export var imageIcon = "_dh-8";
export var lowProfileImageContainer = "_dh-b";
export var lowProfileImageIcon = "_dh-f";
export var lowProfileImageIconContainer = "_dh-e";
export var lowProfileImagePlaceholder = "_dh-d";
export var lowProfileProductImage = "_dh-c";
export var lowProfileProductUpsellWidgetPreview = "_dh-a";
export var productCard = "_dh-5";
export var productImage = "_dh-7";
export var productReviewsWidgetPreview = "_dh-h";
export var progressBar = "_dh-1";
export var progressBarFill = "_dh-2";
export var progressBarTrack = "_dh-3";
export var shippingOptionWidgetPreview = "_dh-j";
export var shippingUpsellProgressBar = "_dh-k";
export var thresholdUpsellWidgetPreview = "_dh-0";